import { jsx as _jsx } from "react/jsx-runtime";
import { useContact3DPlayerRecords } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
import { toCssColorString } from "../util/ColorPreset";
import { ScreenSize, useScreenSize } from "../util/MediaQueries";
import { getLightPlayerColor, getPlayerColor, getWashedPlayerColor } from "../util/PlayerColors";
import { VisualContainer } from "./VisualContainer";
export function getPlayerCardMaxWidth(screenSize) {
    return screenSize === ScreenSize.Large ? '19rem' : '12rem';
}
export const PlayerCard = (props) => {
    var _a;
    const players = useContact3DPlayerRecords();
    const playerRecord = players.record[props.playerId];
    const playerColor = toCssColorString(getPlayerColor(playerRecord === null || playerRecord === void 0 ? void 0 : playerRecord.index));
    const lightPlayerColor = toCssColorString(getLightPlayerColor(playerRecord === null || playerRecord === void 0 ? void 0 : playerRecord.index));
    const washedPlayerColor = toCssColorString(getWashedPlayerColor(playerRecord === null || playerRecord === void 0 ? void 0 : playerRecord.index));
    const innerColor = (playerRecord === null || playerRecord === void 0 ? void 0 : playerRecord.isLocalPlayer) ? washedPlayerColor : playerColor;
    const screenSize = useScreenSize();
    const maxWidth = getPlayerCardMaxWidth(screenSize);
    return _jsx(VisualContainer, Object.assign({}, props, { padding: (_a = props.padding) !== null && _a !== void 0 ? _a : '10px', style: Object.assign({ borderWidth: '3px', borderRadius: '12px', maxWidth, backgroundColor: innerColor, borderColor: lightPlayerColor }, props.style), children: props.children }));
};
//# sourceMappingURL=PlayerCard.js.map